var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "a",
    points: "0 0 95.999 0 95.999 95.999 0 95.999"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.033 48c-1.638 0-2.9674-1.3294-2.9674-2.9674 0-13.84-11.258-25.098-25.098-25.098-1.6439 0-2.9674-1.3294-2.9674-2.9674 0-1.6439 1.3234-2.9674 2.9674-2.9674 17.11 0 31.033 13.917 31.033 31.033 0 1.638-1.3294 2.9674-2.9674 2.9674",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m6 41.309c0-19.47 15.84-35.31 35.31-35.31s35.31 15.84 35.31 35.31-15.84 35.316-35.31 35.316-35.31-15.846-35.31-35.316m89.01 49.464-23.556-21.312c6.906-7.386 11.166-17.274 11.166-28.152 0-22.776-18.534-41.31-41.31-41.31s-41.31 18.534-41.31 41.31c0 22.782 18.534 41.316 41.31 41.316 9.732 0 18.672-3.408 25.74-9.06l23.94 21.66c0.576 0.516 1.29 0.774 2.01 0.774 0.816 0 1.632-0.33 2.226-0.99 1.11-1.224 1.014-3.12-0.216-4.236",
    fill: "#fff",
    mask: "url(#b)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLens);
export default __webpack_public_path__ + "static/media/lens.b893a1a4fcc47652920284ece61cdd6c.svg";
export { ForwardRef as ReactComponent };